import { render, staticRenderFns } from "./DodCustomers.vue?vue&type=template&id=b946144e&scoped=true&"
import script from "./DodCustomers.vue?vue&type=script&lang=js&"
export * from "./DodCustomers.vue?vue&type=script&lang=js&"
import style0 from "./DodCustomers.vue?vue&type=style&index=0&id=b946144e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946144e",
  null
  
)

export default component.exports